<template>
  <div id="event-plan-details">
    <v-card class="eligibility-popup" elevation="8">
      <!-- Professional Header -->
      <v-card-title class="eligibility-header pa-0">
        <div class="header-content">
          <div class="header-icon-section">
            <v-icon size="32" color="white">mdi-clipboard-check-outline</v-icon>
          </div>
          <div class="header-text-section">
            <h3 class="header-title">Eligibility Criteria</h3>
            <p class="header-subtitle">{{ Plan.NominationDesignationName }}</p>
          </div>
          <v-btn
            icon
            small
            color="white"
            class="close-btn"
            @click.prevent="closePrompt"
          >
            <v-icon size="20">mdi-close</v-icon>
          </v-btn>
        </div>
      </v-card-title>

      <!-- Professional Content Area -->
      <v-card-text class="eligibility-content pa-6">
        <div class="content-wrapper">
          <div class="criteria-section">
            <div class="section-header mb-4">
              <v-icon color="#1976d2" size="20" class="mr-2"
                >mdi-information-outline</v-icon
              >
              <span class="section-title">Requirements & Guidelines</span>
            </div>

            <div class="description-content" v-html="Plan.Description" />
          </div>
        </div>
      </v-card-text>

      <!-- Professional Footer -->
      <v-card-actions class="eligibility-footer pa-4">
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          class="close-button"
          elevation="2"
          @click.prevent="closePrompt"
        >
          <v-icon left size="18">mdi-check</v-icon>
          Got it
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
export default {
  props: {
    Plan: {
      required: true,
    },
  },
  data() {
    return {};
  },
  methods: {
    closePrompt() {
      console.log("closePrompt called");
      this.$emit("hideDialog");
    },
  },
};
</script>

<style lang="scss" scoped>
#event-plan-details {
  .eligibility-popup {
    border-radius: 16px !important;
    overflow: hidden;
    max-width: 600px;
    margin: 0 auto;

    .eligibility-header {
      background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);
      color: white;
      position: relative;

      .header-content {
        display: flex;
        align-items: center;
        width: 100%;
        padding: 1.5rem;

        .header-icon-section {
          background: rgba(255, 255, 255, 0.2);
          border-radius: 12px;
          padding: 0.75rem;
          margin-right: 1rem;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .header-text-section {
          flex: 1;

          .header-title {
            font-size: 1.25rem;
            font-weight: 600;
            margin: 0;
            color: white;
            font-family: "Roboto", sans-serif;
          }

          .header-subtitle {
            font-size: 0.9rem;
            margin: 0.25rem 0 0 0;
            opacity: 0.9;
            font-weight: 400;
          }
        }

        .close-btn {
          background: rgba(255, 255, 255, 0.2) !important;
          transition: all 0.2s ease;

          &:hover {
            background: rgba(255, 255, 255, 0.3) !important;
            transform: scale(1.05);
          }
        }
      }
    }

    .eligibility-content {
      background: #fafafa;

      .content-wrapper {
        .criteria-section {
          .section-header {
            display: flex;
            align-items: center;
            border-bottom: 2px solid #e3f2fd;
            padding-bottom: 0.75rem;

            .section-title {
              font-size: 1.1rem;
              font-weight: 600;
              color: #2c3e50;
              font-family: "Roboto", sans-serif;
            }
          }

          .description-content {
            background: white;
            padding: 1.5rem;
            border-radius: 8px;
            border-left: 4px solid #1976d2;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
            font-size: 0.95rem;
            line-height: 1.7;
            color: #424242;

            // Style for HTML content
            :deep(h1),
            :deep(h2),
            :deep(h3),
            :deep(h4),
            :deep(h5),
            :deep(h6) {
              color: #2c3e50;
              font-weight: 600;
              margin-bottom: 0.75rem;
              font-family: "Roboto", sans-serif;
            }

            :deep(p) {
              margin-bottom: 1rem;
              color: #424242;
              line-height: 1.7;
            }

            :deep(ul),
            :deep(ol) {
              padding-left: 1.5rem;
              margin-bottom: 1rem;

              li {
                margin-bottom: 0.5rem;
                color: #424242;
                line-height: 1.6;
              }
            }

            :deep(strong),
            :deep(b) {
              color: #2c3e50;
              font-weight: 600;
            }

            :deep(em),
            :deep(i) {
              color: #1976d2;
              font-style: italic;
            }

            :deep(blockquote) {
              border-left: 3px solid #1976d2;
              padding-left: 1rem;
              margin: 1rem 0;
              font-style: italic;
              color: #666;
            }
          }
        }
      }
    }

    .eligibility-footer {
      background: white;
      border-top: 1px solid #e0e0e0;

      .close-button {
        min-width: 100px;
        font-weight: 500;
        text-transform: none;
        border-radius: 8px;
        transition: all 0.2s ease;

        &:hover {
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(25, 118, 210, 0.3);
        }
      }
    }
  }
}

// Responsive Design
@media (max-width: 768px) {
  #event-plan-details {
    .eligibility-popup {
      margin: 1rem;
      max-width: calc(100vw - 2rem);

      .eligibility-header .header-content {
        padding: 1rem;

        .header-icon-section {
          padding: 0.5rem;
          margin-right: 0.75rem;
        }

        .header-text-section .header-title {
          font-size: 1.1rem;
        }
      }

      .eligibility-content {
        padding: 1rem;

        .description-content {
          padding: 1rem;
          font-size: 0.9rem;
        }
      }
    }
  }
}

@media (max-width: 480px) {
  #event-plan-details {
    .eligibility-popup {
      .eligibility-header .header-content {
        flex-direction: column;
        text-align: center;

        .header-icon-section {
          margin-right: 0;
          margin-bottom: 0.75rem;
        }

        .close-btn {
          position: absolute;
          top: 0.75rem;
          right: 0.75rem;
        }
      }
    }
  }
}
</style>